import { Directive, EventEmitter, Output, Input } from '@angular/core';
import { Ciudad } from '../models/tipo/ciudad.class';

@Directive({
    selector: '[appValidarCiudad]',
    host: {
        '(blur)': 'onBlur()'
    }
})
export class ValidarCiudadDirective {

    @Input() ngModel;
    @Input() listCiudades: Ciudad[];
    @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
    @Input() panelOpen: boolean;


    transformada: string;
    constructor() { }

    onBlur() {

        if (this.listCiudades !== null && this.ngModel !== null && this.ngModel !== '') {
            if (this.validacionesGenerales() && !this.panelOpen) {
                this.reiniciarModelo();
            }

        }

    }

    validacionesGenerales(): boolean {
        return this.ngModel !== null && this.ngModel !== '' &&
            this.ngModel.descripcioncompleta === undefined;
    }


    reiniciarModelo(): void {
        this.ngModel = null;
        this.ngModelChange.emit(this.ngModel);
    }

}



// WEBPACK FOOTER //
// ./src/app/directives/validar-ciudad.directive.ts